import { Droplets, QrCode, Clock, Bell } from 'lucide-react';

const benefits = [
  {
    icon: Droplets,
    title: 'غسلات بلا حدود',
    description: 'حتى ٦ غسلات شهرياً في أي مغسلة',
  },
  {
    icon: QrCode,
    title: 'رمز QR فوري',
    description: 'اعرض الرمز واغسل سيارتك بثوانٍ',
  },
  {
    icon: Clock,
    title: 'تتبع مباشر',
    description: 'اترك سيارتك وتتبع الطابور من هاتفك',
  },
  {
    icon: Bell,
    title: 'إشعار عند الجاهزية',
    description: 'نعلمك فوراً عندما تكون سيارتك جاهزة',
  },
];

export default function BenefitsSection() {
  return (
    <section className="py-16 px-4 bg-white">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12 anim-fade-up">
          <h2 className="text-2xl md:text-3xl font-bold text-text-brand font-cairo mb-2">لماذا رمبا؟</h2>
          <p className="text-text-muted">كل ما تحتاجه في تطبيق واحد</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {benefits.map((item, i) => {
            const Icon = item.icon;
            return (
              <div
                key={item.title}
                className={`anim-fade-up delay-${i + 1} bg-surface rounded-2xl p-5 md:p-6 text-center hover:shadow-md transition-all group`}
              >
                <div className="w-12 h-12 rounded-xl bg-primary-50 flex items-center justify-center mx-auto mb-4 group-hover:bg-primary-100 transition-colors">
                  <Icon className="w-6 h-6 text-primary-600" />
                </div>
                <h3 className="text-sm md:text-base font-bold text-text-brand mb-1.5">{item.title}</h3>
                <p className="text-text-muted text-xs md:text-sm leading-relaxed">{item.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
